// extracted by mini-css-extract-plugin
export default {"partners":"Partner_partners__+ffQx","swiper-slide":"Partner_swiper-slide__hnEcO","partner":"Partner_partner__26XEs"};